var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index"},[_c('el-row',{staticClass:"title"},[_vm._v("欢迎来到星罗好货提报平台")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }